import {SortingModelAbstract} from "@/models/SortingModelAbstract";
import {SORT_ARGS} from "@/app/exercise/modules/users/core/models/UsersConst";

export class UserSortingModel extends SortingModelAbstract {
  constructor(query) {
    super(SORT_ARGS);

    this.by = [];
    this.desc = [];
    this.ordering = null;
    this._apiAttributes = {
      id: 'id',
      email: 'email',
      first_name: 'nu_exams_profile__first_name',
      last_name: 'nu_exams_profile__last_name',
    };
    this._customSorting = {};
    this._orderingFields = {
      id: 'id',
      email: 'email',
      first_name: 'nu_exams_profile__first_name',
      last_name: 'nu_exams_profile__last_name'
    };
    this._initByQuery(query);
  }

}
